<div class="payment-option-container" (click)="$event.stopPropagation()">
  <form [formGroup]="paymentFormGroup">
    <mat-radio-group class="payment-radio" formControlName="paymentType">
      <!-- KITS Wallet [FOR KITS AFFILIATES ONLY] -->
      <mat-radio-button
        [value]="paymentOptionKITS"
        [checked]="paymentChannelVal == paymentOptionKITS"
        class="payment-radio__btn"
        *ngIf="
          !onlyFullPayment &&
          (!paymentOptionsCondition || paymentOptionsCondition.enableMPay) &&
          partnerCode == 'kits'
        "
        (change)="fpKITSSelected($event)"
      >
        <div class="payment-radio__label">KITS Wallet</div>

        <div class="mt-xs payment-radio__bold">
          <span>RM {{ this.totalPriceBeforeCharges | number : "1.2-2" }}</span>
        </div>

        <div class="payment-radio__icon-copy">
          <img
            src="/assets/icons/payments/e-wallet/kits-logo.png"
            alt=""
            class="kits-icon"
          />
        </div>
      </mat-radio-button>

      <!-- Payment Option: Credit/Debit/E-wallet -->
      <div
        class="payment-radio__btn"
        *ngIf="
          !paymentOptionsCondition || paymentOptionsCondition.enableFullPrice
        "
      >
        <mat-radio-button
          class="fp-margin"
          [value]="paymentOptionFullPrice"
          [checked]="
            paymentTypeVal == paymentOptionFullPrice &&
            paymentOptionFPTypeVal == paymentOptionRazer
          "
          (change)="fpRazerSelected($event)"
        >
        <div class="payment-header-flex">
          <div *ngIf = "!isEndorsement" class="payment-radio__label">Credit/Debit/E-wallet</div>
          <div *ngIf = "isEndorsement" class="payment-radio__label">Credit/Debit</div>
          
          <div class="tried-badge" *ngIf="isPreviousTried('Razer')">
            <mat-icon class="info-icon">info_outline</mat-icon>
            <span> {{ "response.previousTried" | translate }}</span>
          </div>
        </div>

          <div class="payment-radio__bold">
            RM {{ this.totalPriceBeforeCharges | number : "1.2-2" }}
          </div>

          <div *ngIf = "!isEndorsement">
            <img 
              src="/assets/icons/payments/full-price.svg"
              alt=""
              class="payment-radio__btn__icon"
              />
          </div>
          <div *ngIf = "isEndorsement">
            <img
              src="/assets/icons/payments/full-price-1.png"
              alt=""
              class="payment-radio__btn__icon"
            />
          </div>
                 
        </mat-radio-button>

        <mat-radio-group
          *ngIf="
            paymentTypeVal == paymentOptionFullPrice &&
            paymentOptionFPTypeVal == paymentOptionRazer
          "
          class="payment-radio full-price"
          formControlName="paymentChannel"
        >
          <div class="ml-lg mb-sm mt-md">
            {{ "paymentOptions.paymentMethod" | translate }}
          </div>

          <!-- Credit/Debit/E-wallet: Visa / Mastercard -->
          <mat-radio-button [checked]="true" [value]="paymentOptionVisa">
            <div>Visa / Mastercard</div>
            <img
              src="/assets/icons/payments/full-price-1.png"
              alt=""
              class="full-price__icon"
            />
          </mat-radio-button>

          <!-- Credit/Debit/E-wallet: Online Banking (FPX) -->
          <mat-radio-button [checked]="false" [value]="paymentOptionFpx">
            <div>Online Banking (FPX)</div>
            <img
              src="/assets/icons/payments/full-price-2.png"
              alt=""
              class="full-price__icon"
            />
          </mat-radio-button>

          <!-- Credit/Debit/E-wallet: Online Banking (FPX for Enterprise) -->
          <mat-radio-button
            [checked]="false"
            [value]="paymentOptionFpxEnterprise"
          >
            <div>Online Banking (FPX for Enterprise)</div>
            <img
              src="/assets/icons/payments/full-price-2.png"
              alt=""
              class="full-price__icon"
            />
          </mat-radio-button>

          <mat-form-field
            appearance="outline"
            *ngIf="paymentChannelVal == paymentOptionFpxEnterprise"
            class="e-wallet-form"
          >
            <mat-label>
              {{ "paymentOptions.selectFpxEnterpriseBank" | translate }}
            </mat-label>
            <mat-select
              disableOptionCentering
              required
              formControlName="fpxEnterpriseType"
            >
              <mat-option
                *ngFor="let item of fpxEnterpriseTypeListing"
                [value]="item?.value"
              >
                <span class="ewallet-options">
                  <img [src]="item?.img" alt="" />
                  {{ item?.name }}
                </span>
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Credit/Debit/E-wallet: e-Wallet -->
          <mat-radio-button
            [checked]="false"
            [value]="paymentOptionEwallet"
            *ngIf="allowEwallet"
          >
            <div>e-Wallet</div>
            <img
              src="/assets/icons/payments/full-price-3.svg"
              alt=""
              class="full-price__icon"
            />
          </mat-radio-button>

          <mat-form-field
            appearance="outline"
            *ngIf="paymentChannelVal == paymentOptionEwallet"
            class="e-wallet-form"
          >
            <mat-label>
              {{ "paymentOptions.selectEWallet" | translate }}
            </mat-label>
            <mat-select
              disableOptionCentering
              required
              formControlName="ewalletType"
            >
              <mat-option
                *ngFor="let item of ewalletTypeListing"
                [value]="item?.value"
              >
                <span class="ewallet-options">
                  <img [src]="item?.img" alt="" />
                  {{ item?.name }}
                </span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </mat-radio-group>
      </div>
      <!-- MSD -->
      <mat-radio-button
        [value]="paymentOptionMSD"
        [checked]="paymentTypeVal == paymentOptionMSD"
        class="payment-radio__btn"
        *ngIf="partnerCode === 'prolindung'"
      >
        <div class="payment-radio__label">
          {{ "paymentOptions.MSD" | translate }} (KOPETRO)
        </div>
        <div class="mt-xs">
          <span style="white-space: normal">
            {{ "paymentOptions." + partnerCode + "MSDdesc" | translate }}
          </span>
        </div>
        <div class="payment-radio__shopee-copy">
          <img
            src="/assets/icons/payments/kopetro.png"
            alt=""
            style="width: 40px"
          />
        </div>
      </mat-radio-button>
      <!-- Atome BNPL -->
      <mat-radio-button
        *ngIf="
          !onlyFullPayment &&
          (!paymentOptionsCondition || paymentOptionsCondition.enableAtome) && !disabledAtome
        "
        class="payment-radio__btn"
        [value]="paymentOptionBNPL"
        [checked]="paymentChannelVal == paymentOptionAtome"
        (change)="atomeBNPLSelected($event)"
      >
      <div class="payment-header-flex">
        <div class="payment-radio__label">{{ "common.atome" | translate }}</div>
          
          <div class="tried-badge" *ngIf="isPreviousTried('Atome')">
            <mat-icon class="info-icon">info_outline</mat-icon>
            <span> {{ "response.previousTried" | translate }}</span>
          </div>
        </div>
        <div class="mt-xs">
          <span>
            <div
              class="payment-radio__label"
              [innerHTML]="'common.atomeBNPL' | translate"
            ></div>
          </span>
        </div>
        <div>
          <img
            src="/assets/icons/payments/AtomeBNPL.png"
            alt=""
            class="payment-radio__btn__icon"
          />
        </div>
      </mat-radio-button>

      <!-- Aha Pay BNPL -->
      <mat-radio-button
        *ngIf="!onlyFullPayment && (!paymentOptionsCondition || paymentOptionsCondition.enableAhaPay) && !disabledAhapay"
        class="payment-radio__btn"
        [value]="paymentOptionBNPL"
        [checked]="paymentChannelVal == paymentOptionAhaPay"
        (change)="ahaPayBNPLSelected($event)"
      >
        <div class="payment-header-flex" *ngIf="isPreviousTried('AhaPay')">          
          <div class="tried-badge">
            <mat-icon class="info-icon">info_outline</mat-icon>
            <span> {{ "response.previousTried" | translate }}</span>
          </div>
        </div>
         <div class="payment-radio__label" [innerHTML]="'common.ahapay' | translate"></div>
        <div class="mt-xs">
          <span>
            <div class="payment-radio__label" [innerHTML]="'common.ahapayBNPL' | translate"></div>
          </span>
        </div>
        <div>
          <img src="/assets/icons/payments/AhaPayBNPL.png" alt="" class="payment-radio__btn__icon" />
        </div>
      </mat-radio-button>

      <!-- Shopee Pay -->
      <mat-radio-button
        [value]="paymentOptionFullPrice"
        [checked]="
          paymentTypeVal == paymentOptionFullPrice &&
          paymentOptionFPTypeVal == paymentOptionShopee
        "
        class="payment-radio__btn"
        *ngIf="
          !onlyFullPayment &&
          (!paymentOptionsCondition || paymentOptionsCondition.enableShopeePay)
        "
        (change)="fpShopeeSelected($event)"
      >
        <div class="payment-header-flex">
        <div class="payment-radio__label">SPayLater / ShopeePay</div>
          
          <div class="tried-badge" *ngIf="isPreviousTried('ShopeePay')">
            <mat-icon class="info-icon">info_outline</mat-icon>
            <span> {{ "response.previousTried" | translate }}</span>
          </div>
        </div>
        <div class="mt-xs">
          <span>
            {{ "paymentOptions.ScanQRAndChooseInstalmentsUp" | translate }}
            <br />
            {{ "paymentOptions.to12Months" | translate }}.
          </span>
        </div>
        <div class="payment-radio__icon-copy">
          <img
            src="/assets/icons/payments/spaylater_spay.png"
            alt=""
            class="shopee-icon"
          />
        </div>
      </mat-radio-button>

      <!-- Grab Pay -->
      <mat-radio-button
        [value]="paymentOptionFullPrice"
        [checked]="
          paymentTypeVal == paymentOptionFullPrice &&
          paymentOptionFPTypeVal == paymentOptionGrab
        "
        class="payment-radio__btn"
        *ngIf="
          !onlyFullPayment &&
          (!paymentOptionsCondition || paymentOptionsCondition.enableGrabPay)
        "
        (change)="fpGrabSelected($event)"
      >
        <div class="payment-header-flex">
          <div class="payment-radio__label">GrabPay / PayLater by Grab</div>
          
          <div class="tried-badge" *ngIf="isPreviousTried('GrabPay')">
            <mat-icon class="info-icon">info_outline</mat-icon>
            <span> {{ "response.previousTried" | translate }}</span>
          </div>
        </div>
        <div class="mt-xs">
          <span [innerHtml]="'paymentOptions.grabPayDesc' | translate"></span>
        </div>

        <div class="payment-radio__icon-copy">
          <img
            src="/assets/icons/payments/grabpay.png"
            alt=""
            class="grab-icon"
          />
        </div>
      </mat-radio-button>

      <!-- Shopback
      <mat-radio-button
        [value]="paymentOptionShopback"
        [checked]="paymentTypeVal == paymentOptionShopback"
        class="payment-radio__btn"
        *ngIf="
          !onlyFullPayment &&
          (!paymentOptionsCondition || paymentOptionsCondition.enableShopback)
        "
      >
        <div class="payment-radio__label">
          {{ "common.shopback" | translate }}
        </div>
        <div class="mt-xs payment-radio__bold">
          <span>RM {{ this.totalPriceBeforeCharges | number : "1.2-2" }}</span>
        </div>
        <div class="payment-radio__icon-copy">
          <span class="bold">{{ "common.shopbackPay" | translate }}&nbsp;</span>
          {{ "common.shopbackGet" | translate }}&nbsp;
          <span class="shopback-orange">
            {{ "common.shopbackCashback" | translate }}</span
          >
          <img
            src="/assets/icons/payments/shopback.png"
            alt=""
            class="shopback-icon"
          />
        </div>
      </mat-radio-button>
       -->

      <!-- Lenda Pay -->
      <mat-radio-button
        *ngIf="!paymentOptionsCondition || paymentOptionsCondition.enableLendaPay"
        class="payment-radio__btn"
        (change)="lendaPayBNPLSelected()"
        [value]="paymentOptionBNPL"
        [checked]="paymentChannelVal == paymentOptionLendaPay"
      >
        <div class="payment-header-flex">
          <div class="payment-radio__label">
            {{ "common.lendaPay" | translate }}
          </div>
          <div class="tried-badge" *ngIf="isPreviousTried('LendaPay')">
            <mat-icon class="info-icon">info_outline</mat-icon>
            <span>
              {{ "response.previousTried" | translate }}
            </span>
          </div>
        </div>
        <div class="mt-xs">
          <span>
            {{ "common.lendaPayDesc" | translate }}
          </span>
        </div>
        <div>
          <img
            src="/assets/icons/payments/LendaPay.png"
            alt=""
            class="payment-radio__btn__icon"
          />
        </div>
      </mat-radio-button>
      
      <!-- EPP Razer -->
      <mat-radio-button
        [value]="paymentOptionEPP"
        [checked]="
          this.paymentFormGroup?.value?.paymentOptionEPPType ==
          paymentOptionEPP3Or6Or12Months
        "
        class="payment-radio__btn"
        *ngIf="
          showEPP3Or6Or12Months &&
          !onlyFullPayment &&
          (!paymentOptionsCondition ||
            paymentOptionsCondition.enableRazerEPP) &&
          partnerCode !== 'prolindung'
        "
        (change)="epp3Or6Or12MonthsSelected($event)"
      >
      <div class="payment-header-flex">
        <div class="payment-radio__label">
          {{ "paymentOptions.eppDuration" | translate }}
        </div>          
          <div class="tried-badge" *ngIf="isPreviousTried('RazerEPP')">
            <mat-icon class="info-icon">info_outline</mat-icon>
            <span> {{ "response.previousTried" | translate }}</span>
          </div>
        </div>
        
        <div class="mt-xs">
          <span>{{ "paymentOptions.epp" | translate }}</span>
          <span class="gap"></span>
          <img
            src="/assets/icons/payments/rms.png"
            alt=""
            class="payment-radio__btn__icon"
          />
        </div>
        <img
          src="https://storage.googleapis.com/dev-ps-asset/payment_bank_logos/razer-banks.png"
          alt=""
          class="razer-banks"
        />
        <div
          class="payment-radio__btn__epp"
          *ngIf="
            this.paymentFormGroup?.value?.paymentOptionEPPType ==
            paymentOptionEPP3Or6Or12Months
          "
        >
          <mat-form-field appearance="outline">
            <mat-label>{{ "paymentOptions.cardIssuer" | translate }}</mat-label>
            <mat-select
              disableOptionCentering
              formControlName="bank"
              (selectionChange)="eppBankSelected($event.value)"
            >
              <mat-option
                *ngFor="let item of epp3Or6Or12MonthsChargeDistinctList"
                [value]="item?.bankName"
                class="epp-options"
              >
                <span class="ewallet-options">
                  <img [src]="item?.bankLogoUrl" alt="" />
                  {{ item?.bankName }}
                </span>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            *ngIf="this.paymentFormGroup?.value?.bank"
          >
            <mat-label>{{
              "paymentOptions.monthlyOption" | translate
            }}</mat-label>
            <mat-select
              disableOptionCentering
              formControlName="installmentMonth"
            >
              <mat-option
                *ngFor="
                  let item of filterListBasedOnSelectedBanks(
                    epp3Or6Or12MonthsChargeList
                  )
                "
                [value]="item?.installmentPeriod"
                class="epp-options"
              >
                {{ getPaymentMonthLabel(item.installmentPeriod) | translate }}
                (<span class="epp-options__bold">
                  RM
                  {{
                    getTotalPriceInstallment(item.installmentPeriod)
                      | number : "1.2-2"
                  }}
                </span>
                {{ "common.perMonth" | translate }})
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </mat-radio-button>
      <!-- EPP Payex -->
      <mat-radio-button
        [value]="paymentOptionEPP"
        [checked]="
          this.paymentFormGroup?.value?.paymentOptionEPPType ==
          paymentOptionEPP6Or12Months
        "
        class="payment-radio__btn"
        *ngIf="
          showEPP6Or12Months &&
          !onlyFullPayment &&
          (!paymentOptionsCondition ||
            paymentOptionsCondition.enablePayexEPP) &&
          partnerCode !== 'prolindung'
        "
        (change)="epp6or12MonthsSelected($event)"
      >
      <div class="payment-header-flex">
         <div class="payment-radio__label">
          {{ "paymentOptions.6or12months" | translate }}
        </div>          
          <div class="tried-badge" *ngIf = "isPreviousTried('PayexEPP')">
            <mat-icon class="info-icon">info_outline</mat-icon>
            <span> {{ "response.previousTried" | translate }}</span>
          </div>
        </div>
       
        <div class="mt-xs">
          <span>{{ "paymentOptions.epp" | translate }}</span>
          <span class="gap"></span>
          <img
            src="/assets/icons/payments/payex.png"
            alt=""
            class="full-price__icon"
          />
        </div>
        <div class="mt-xs">
          <img
            src="https://storage.googleapis.com/dev-ps-asset/payment_bank_logos/payex-banks.png"
            alt=""
            class="payex-banks"
          />
        </div>
        <div
          class="payment-radio__btn__epp"
          *ngIf="
            this.paymentFormGroup?.value?.paymentOptionEPPType ==
            paymentOptionEPP6Or12Months
          "
        >
          <mat-form-field appearance="outline">
            <mat-label>{{ "paymentOptions.cardIssuer" | translate }}</mat-label>
            <mat-select
              disableOptionCentering
              formControlName="bank"
              (selectionChange)="eppBankSelected($event.value)"
            >
              <mat-option
                *ngFor="let item of epp6Or12MonthsChargeDistinctList"
                [value]="item?.bankName"
                class="epp-options"
              >
                <span class="ewallet-options">
                  <img [src]="item?.bankLogoUrl" alt="" />
                  {{ item?.bankName }}
                </span>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field
            appearance="outline"
            *ngIf="this.paymentFormGroup?.value?.bank"
          >
            <mat-label>{{
              "paymentOptions.monthlyOption" | translate
            }}</mat-label>
            <mat-select
              disableOptionCentering
              formControlName="installmentMonth"
            >
              <mat-option
                *ngFor="
                  let item of filterListBasedOnSelectedBanks(
                    epp6Or12MonthsChargeList
                  )
                "
                [value]="item?.installmentPeriod"
                class="epp-options"
              >
                {{ getPaymentMonthLabel(item.installmentPeriod) | translate }}
                (<span class="epp-options__bold">
                  RM
                  {{
                    getTotalPriceInstallment(item.installmentPeriod)
                      | number : "1.2-2"
                  }}
                </span>
                {{ "common.perMonth" | translate }})
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </mat-radio-button>
      <!-- Atome BNPL -->
      <!-- <mat-radio-button
                *ngIf="!onlyFullPayment"
                class="payment-radio__btn"
                [value]="paymentOptionBNPL"
                [checked]="paymentChannelVal == paymentOptionAtome">
                <div class="payment-radio__label">{{ "common.atome" | translate }}</div>
                <div class="payment-radio__label">{{ "common.atomeBNPL" | translate }}</div>
                <div>
                    <img src="/assets/icons/payments/AtomeBNPL.png" alt="" class="payment-radio__btn__icon" />
                </div>
         </mat-radio-button> -->
    </mat-radio-group>
  </form>
</div>
